import React from 'react';

export const filterDone = (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23 1L9.02802 16L1 9.25001" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const filterClose = (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.91421 8.5L16.7071 1.70711C17.0976 1.31658
    17.0976 0.683418 16.7071 0.292893C16.3166 -0.0976311 15.6834 -0.0976311 15.2929 0.292893L8.5
    7.08579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311
    0.683418 -0.0976311 1.31658 0.292893 1.70711L7.08579 8.5L0.292892 15.2929C-0.0976318 15.6834
    -0.0976318 16.3166 0.292892 16.7071C0.683417 17.0976 1.31658 17.0976 1.70711 16.7071L8.5 9.91421L15.2929
    16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071
    15.2929L9.91421 8.5Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const modalClose = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4142 16L31.7071 1.70711C32.0976 1.31658 32.0976
    0.683418 31.7071 0.292893C31.3166 -0.0976311 30.6834 -0.0976311 30.2929 0.292893L16 14.5858L1.70711
    0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683418 -0.0976311
    1.31658 0.292893 1.70711L14.5858 16L0.292892 30.2929C-0.0976318 30.6834 -0.0976318 31.3166 0.292892
    31.7071C0.683417 32.0976 1.31658 32.0976 1.70711 31.7071L16 17.4142L30.2929 31.7071C30.6834 32.0976
    31.3166 32.0976 31.7071 31.7071C32.0976 31.3166 32.0976 30.6834 31.7071 30.2929L17.4142 16Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const filterIcon = (
  <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>filter</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1-Copy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Category-promocod" transform="translate(-1421.000000, -300.000000)" fill="#FFFFFF" fillRule="nonzero">
        <g id="filter/grid" transform="translate(1401.000000, 290.000000)">
          <g
            id="Filter"
            transform="translate(30.500000, 20.500000) rotate(-90.000000) translate(-30.500000, -20.500000)
           translate(21.000000, 11.000000)"
          >
            <path
              d="M11,10.1260175 C12.7252272,10.5700603 14,12.1361606 14,14 C14,15.8638394 12.7252272,17.4299397
            11,17.8739825 L11,19 C11,19.5522847 10.5522847,20 10,20 C9.44771525,20 9,19.5522847 9,19 L9,17.8739825
            C7.27477279,17.4299397 6,15.8638394 6,14 C6,12.1361606 7.27477279,10.5700603 9,10.1260175
            L9,1.77635684e-15 C9,-0.55228475 9.44771525,-1 10,-1 C10.5522847,-1 11,-0.55228475 11,1.77635684e-15
            L11,10.1260175 Z M10.1812423,12.0081015 C10.1224632,12.0188626 10.0618881,12.0244846 10,12.0244846
            C9.93811186,12.0244846 9.87753681,12.0188626 9.8187577,12.0081015 C8.79911905,12.0996904 8,12.9565231
            8,14 C8,15.1045695 8.8954305,16 10,16 C11.1045695,16 12,15.1045695 12,14 C12,12.9565231
            11.2008809,12.0996904 10.1812423,12.0081015 Z M4,1.12601749 C5.72522721,1.57006028 7,3.13616057
            7,5 C7,6.86383943 5.72522721,8.42993972 4,8.87398251 L4,19 C4,19.5522847 3.55228475,20 3,20
            C2.44771525,20 2,19.5522847 2,19 L2,8.87398251 C0.274772787,8.42993972 -1,6.86383943 -1,5 C-1,3.13616057
            0.274772787,1.57006028 2,1.12601749 L2,-8.10462808e-15 C2,-0.55228475 2.44771525,-1 3,-1 C3.55228475,-1
            4,-0.55228475 4,1.11022302e-15 L4,1.12601749 Z M2.88860703,6.99695028 C2.92517947,6.99289693
            2.96234671,6.99081589 3,6.99081589 C3.03765329,6.99081589 3.07482053,6.99289693 3.11139297,6.99695028
            C4.16414798,6.93915658 5,6.06719014 5,5 C5,3.8954305 4.1045695,3 3,3 C1.8954305,3 1,3.8954305
            1,5 C1,6.06719014 1.83585202,6.93915658 2.88860703,6.99695028 Z M17,1.12601749 C18.7252272,1.57006028
            20,3.13616057 20,5 C20,6.86383943 18.7252272,8.42993972 17,8.87398251 L17,19 C17,19.5522847 16.5522847,20
            16,20 C15.4477153,20 15,19.5522847 15,19 L15,8.87398251 C13.2747728,8.42993972 12,6.86383943 12,5
            C12,3.13616057 13.2747728,1.57006028 15,1.12601749 L15,-1.77635684e-15 C15,-0.55228475 15.4477153,-1
            16,-1 C16.5522847,-1 17,-0.55228475 17,-1.77635684e-15 L17,1.12601749 Z M15.3614984,6.89591391
            C15.5347051,6.75206283 15.7572516,6.66556834 16,6.66556834 C16.2427484,6.66556834 16.4652949,6.75206283
            16.6385016,6.89591391 C17.4299737,6.62946642 18,5.8813016 18,5 C18,3.8954305 17.1045695,3 16,3
            C14.8954305,3 14,3.8954305 14,5 C14,5.8813016 14.5700263,6.62946642 15.3614984,6.89591391 Z"
              id="filter"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const arrowUp = (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.862 1.78258C11.0417 1.60693 11.043 1.30675 10.8829 1.13763C10.7203 0.965749 10.4218
    0.953141 10.2509 1.11632L6.44537 4.49793C6.44537 4.49793 6.1429 4.85238 6 4.85238C5.8571 4.85238
    5.55649 4.49793 5.55649 4.49793L1.75099 1.11632C1.5801 0.953005 1.27895 0.963073 1.11895 1.13763C0.958951
    1.31206 0.954995 1.59274 1.13984 1.78258L5.69533 5.88702C5.90333 6.05949 6.15826 6.01414 6.30652
    5.88702L10.862 1.78258Z"
      fill="#616161"
      stroke="#616161"
    />
  </svg>
);

export const arrowDown = (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.862 5.21742C11.0417 5.39307 11.043 5.69325 10.8829 5.86237C10.7203 6.03425 10.4218
    6.04686 10.2509 5.88368L6.44537 2.50207C6.44537 2.50207 6.1429 2.14762 6 2.14762C5.8571 2.14762
    5.55649 2.50207 5.55649 2.50207L1.75099 5.88368C1.5801 6.04699 1.27895 6.03693 1.11895 5.86237C0.958951
    5.68794 0.954995 5.40726 1.13984 5.21742L5.69533 1.11298C5.90333 0.940511 6.15826 0.985863 6.30652
    1.11298L10.862 5.21742Z"
      fill="#616161"
      stroke="#616161"
    />
  </svg>
);

export const buttonRight = (
  <svg width="30" height="14" viewBox="0 0 30 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="button arrow" filter="url(#filter0_d)">
      <path
        d="M23.4597 9.68958C23.1041 10.0938 22.4962 10.0967 22.1537 9.73658C21.8057 9.37069 21.7801 8.69899
      22.1106 8.3145L24.9583 6.00208H2.91837C2.41116 6.00208 2 5.55438 2 5.00208C2 4.44979 2.41116 4.00209 2.91837
      4.00209H24.9583L22.1106 1.68972C21.7799 1.30523 21.8002 0.627633 22.1537 0.267636C22.5069 -0.0923612 23.0753
      -0.101261 23.4597 0.314635L27.7712 4.31449C28.1205 4.78249 28.0286 5.35608 27.7712 5.68968L23.4597 9.68958Z"
        fill="white"
      />
    </g>
    <defs>
      <filter id="filter0_d" x="0" y="0" width="30" height="14" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const like = (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 6.40749C20 2.87245 17.1739 0 13.6796 0C12.3361
    0 11.0583 0.428054 9.99967 1.19891C8.94111 0.428084 7.6638 0 6.32125 0C2.82637 0 0 2.8724 0 6.4077C0
    8.25647 0.779822 9.98154 2.11703 11.1907L7.98987 17.161C8.51746 17.6994 9.2304 18 9.9853 18C10.7805
    18 11.495 17.7091 12.0323 17.1643L18.0645 11.0326C18.1224 10.9741 18.1788 10.9108 18.2352 10.8424C19.3386
    9.71199 20 8.11057 20 6.40749ZM13.6796 2C16.062 2 18 3.9698 18 6.40749C18 7.58555 17.5446 8.68824 16.7464
    9.50943C16.6714 9.59513 16.6543 9.61436 16.6407 9.62812L10.6075 15.7608C10.4518 15.9186 10.252 16 9.9853
    16C9.76876 16 9.57043 15.9164 9.4169 15.7597L3.50049 9.74755C2.53698 8.87403 2 7.68616 2 6.4077C2 3.9698
    3.93823 2 6.32125 2C7.44615 2 8.50179 2.44089 9.30176 3.22049L9.99977 3.90072L10.6977 3.22041C11.4974
    2.4409 12.5535 2 13.6796 2Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const activeLike = (
  <svg width="20" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 5.40749C18 2.4212 15.618 0 12.6796 0C11.251 0 9.95512 0.573025 8.99969 1.50432C8.04406
    0.573025 6.74864 0 5.32125 0C2.3822 0 0 2.4212 0 5.4077C0 7.0146 0.691493 8.45771 1.78773 9.44896L7.70263
    15.4596C8.04365 15.8076 8.49916 16 8.9853 16C9.52324 16 9.97814 15.8091 10.3204 15.4621L16.3516
    9.33135C16.3911 9.29145 16.4285 9.24883 16.4635 9.20642C17.4133 8.22917 18 6.88737 18 5.40749Z"
      fill="#E74E1A"
    />
  </svg>
);

export const catalogSize = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H4V4H0V0ZM8 0H12V4H8V0ZM20 0H16V4H20V0ZM0 8H4V12H0V8ZM12
    8H8V12H12V8ZM16 8H20V12H16V8ZM4 16H0V20H4V16ZM8 16H12V20H8V16ZM20 16H16V20H20V16Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const catalogSizeBig = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="tile 4 icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0H0V8H8V0ZM20 0H12V8H20V0ZM0
    12H8V20H0V12ZM20 12H12V20H20V12Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const cart = (
  <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4742 0.399414C5.10732 0.399414 4 1.40894
    4 2.65341V4.03941H1.25926C0.540738 4.03941 0 4.58215 0 5.20963C0.0167888 5.62645 0.0167888
    5.62645 0.0810796 7.15457L0.259589 11.3914C0.356442 13.687 0.431195 15.4524 0.475194 16.481C0.52643
    17.6486 1.51857 18.6006 2.77178 18.5994H13.2291C14.483 18.6005 15.4757 17.646 15.5246 16.4777L15.9991
    5.25502C16.0111 4.95396 15.8994 4.65887 15.6814 4.43128C15.4453 4.18485 15.1045 4.03929 14.7403
    4.03941H12V2.65341C12 1.40894 10.8927 0.399414 9.5258 0.399414H6.4742ZM10 4.03941V2.65341C10 2.41335
    9.78728 2.21941 9.5258 2.21941H6.4742C6.21272 2.21941 6 2.41335 6 2.65341V4.03941H10ZM2.07961
    7.08492L2.02805 5.85942H13.972L13.5261 16.408C13.5166 16.6342 13.3655 16.7795 13.23 16.7794H2.77071C2.63442
    16.7795 2.48353 16.6348 2.47364 16.4093C2.4297 15.382 2.35495 13.6168 2.25811 11.3216L2.25666
    11.2871L2.07961 7.08492Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const arrowBack = (
  <svg width="30" height="14" viewBox="0 0 30 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="button arrow copy" filter="url(#filter0_d)">
      <path
        d="M4.54025 11.6896C4.89594 12.0938 5.50381 12.0967 5.84627 11.7366C6.19434 11.3707 6.21987
      10.699 5.88944 10.3145L3.04168 8.00208L25.0816 8.00208C25.5888 8.00208 26 7.55438 26 7.00208C26
      6.44979 25.5888 6.00209 25.0816 6.00209L3.04168 6.00209L5.88944 3.68972C6.22014 3.30523 6.19976
      2.62763 5.84627 2.26764C5.49307 1.90764 4.92468 1.89874 4.54025 2.31464L0.228794 6.31449C-0.120464
      6.78249 -0.0286255 7.35608 0.228794 7.68968L4.54025 11.6896Z"
        fill="white"
      />
    </g>
    <defs>
      <filter id="filter0_d" x="0" y="0" width="30" height="14" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export const personalIcon = (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9317 18.3937L15.8772 18.1044L16.6173 17.2995C16.9012 16.9907 17.1596 16.6649 17.3815
    16.3369C19.0192 13.9178 19.9797 10.3295 19.4436 7.66726C19.1298 6.10953 18.326 4.87605 17.1148 4.07837C16.4335
    3.6299 15.6163 3.28086 14.7549 3.07236C14.104 2.91459 13.4358 2.84517 12.7489 2.86715H10.6019C9.05317
    2.86715 7.75441 1.78044 7.44432 0.333008L6.02922 0.333008C6.35689 2.53425 8.28186 4.23227 10.6019
    4.23227L12.7627 4.23232C13.3394 4.2123 13.887 4.26839 14.4198 4.39755C15.1233 4.56762 15.7848
    4.84762 16.3368 5.21103C17.2596 5.81866 17.8328 6.72459 18.0761 7.93142C18.5414 10.2422 17.6822
    13.4227 16.2198 15.5825C15.2962 16.9471 13.9293 17.9579 12.7892 17.8102C11.6793 17.6679 10.5763
    16.7577 9.78072 15.5825C8.41637 13.5668 7.57524 10.6233 7.85413 8.37008L6.492 8.0449C6.11105 10.6685
    7.03664 13.9997 8.61881 16.3367C8.82993 16.6486 9.08602 16.9779 9.38224 17.3003L10.1216 18.1052L9.06763
    18.3943C5.49091 19.3754 2.45798 21.6631 0.585938 24.8019L1.81721 25.4443C4.13532 21.5948 8.3619 19.232
    13.0001 19.232C17.6386 19.232 21.8652 21.5948 24.1833 25.4443L25.4146 24.8019C23.5424 21.6628 20.509
    19.3748 16.9317 18.3937Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const google = (
  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="g+_input"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 9.88939C0.5 15.0755 4.70359 19.28
    9.88858 19.28C14.61 19.28 18.103 16.4051 18.8139 11.7338C18.9043 11.1413 18.9499 10.5265 18.95
    9.88937C18.95 9.23815 18.8967 8.60712 18.7904 8.00179L18.7179 7.58822H9.38858V12.1585H14.005C13.3931
    13.7955 11.9366 14.6739 9.88858 14.6739C7.28588 14.6739 5.1564 12.5155 5.1564 9.8893C5.1564 7.24964
    7.30139 5.03575 9.88858 5.03575C11.1292 5.03575 12.1838 5.448 12.9524 6.22253L13.306 6.57884L16.5704
    3.31367L16.2066 2.96023C14.5722 1.37239 12.3542 0.5 9.88858 0.5C4.70379 0.5 0.5 4.70436 0.5 9.88939ZM1.5
    9.88939C1.5 5.25661 5.25611 1.5 9.88858 1.5C11.9117 1.5 13.7318 2.14887 15.1337 3.33628L13.2903
    5.18014C12.3734 4.42977 11.2032 4.03575 9.88858 4.03575C6.74191 4.03575 4.1564 6.70431 4.1564 9.8893C4.1564
    13.0648 6.73055 15.6739 9.88858 15.6739C12.6231 15.6739 14.595 14.2778 15.1612 11.7686L15.2989
    11.1585H10.3886V8.58822H17.8684C17.9227 9.00876 17.95 9.44316 17.95 9.8893C17.9499 10.4765 17.908 11.0409
    17.8253 11.5833C17.1901 15.7569 14.1247 18.28 9.88858 18.28C5.25593 18.28 1.5 14.5232 1.5 9.88939ZM25.3848
    10.0495H28.5V8.83628H25.3848V5.72223H24.172V8.83628H21.0568V10.0495H24.172V13.1622H25.3848V10.0495ZM23.172
    14.1622H26.3848V11.0495H29.5V7.83628H26.3848V4.72223H23.172V7.83628H20.0568V11.0495H23.172V14.1622Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const facebook = (
  <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="facebook_input"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.22575 0.5C5.24172 0.5 3.28878
    2.66677 3.28878 5.92203V7.69141H1.37715C0.883456 7.69141 0.5 8.10633 0.5 8.59943V11.8875C0.5 12.3806
    0.883673 12.7953 1.37715 12.7953H3.28878V20.5922C3.28878 21.0853 3.67228 21.5 4.16593 21.5H7.31242C7.80604
    21.5 8.18956 21.0851 8.18956 20.5922V12.7953H10.5093C11.003 12.7953 11.3865 12.3806 11.3865 11.8875L11.3876
    8.5996C11.3876 8.36688 11.3014 8.14193 11.1447 7.97206C10.9805 7.79399 10.7516 7.69141 10.5103
    7.69141H8.18956V6.26763C8.18956 5.48939 8.28412 5.37358 9.00727 5.37358L10.6232 5.37295C11.1165 5.37295
    11.5 4.95803 11.5 4.46514V1.41197C11.5 0.919609 11.1172 0.505147 10.6244 0.504162L10.6234 1.00416L10.6243
    0.504161L8.22575 0.5ZM4.28878 5.92203C4.28878 3.19722 5.81851 1.5 8.22488 1.5L10.5 1.50395V4.373L9.00708
    4.37358C7.68204 4.37358 7.18956 4.97674 7.18956 6.26762V8.69141H10.3876L10.3865
    11.7953H7.18956V20.5H4.28878V11.7953H1.5V8.69141H4.28878V5.92203Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const lkNotification = (
  <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3727 4.88405C12.3727 6.97848 10.6771 8.67446 8.58432 8.67446C6.49055 8.67446 4.79492
    6.97848 4.79492 4.88405C4.79492 2.79205 6.49034 1.09668 8.58432 1.09668C10.6769 1.09688 12.3727 2.79205
    12.3727 4.88405Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17.2371 18.9815C17.2371 21.5438 1.04102 21.5438 1.04102 18.9815C1.04102 15.1385 4.6652 12.2373
    9.13892 12.2373C13.614 12.2373 17.2371 15.1385 17.2371 18.9815Z"
      stroke="white"
      strokeWidth="2"
    />
    <path d="M20.0469 1.95238H23.8404" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M20.0469 5.76195H23.8404" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path d="M20.0469 9.57152H21.9326" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1907 2.90476C17.7166 2.90476 18.143 2.47837 18.143
    1.95238C18.143 1.4264 17.7166 1 17.1907 1C16.6647 1 16.2383 1.4264 16.2383 1.95238C16.2383 2.47837
    16.6647 2.90476 17.1907 2.90476Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1907 6.71433C17.7166 6.71433 18.143 6.28794 18.143
    5.76195C18.143 5.23597 17.7166 4.80957 17.1907 4.80957C16.6647 4.80957 16.2383 5.23597 16.2383 5.76195C16.2383
    6.28794 16.6647 6.71433 17.1907 6.71433Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1907 10.5239C17.7166 10.5239 18.143 10.0975 18.143
    9.57152C18.143 9.04554 17.7166 8.61914 17.1907 8.61914C16.6647 8.61914 16.2383 9.04554 16.2383 9.57152C16.2383
    10.0975 16.6647 10.5239 17.1907 10.5239Z"
      fill="white"
    />
  </svg>
);

export const lkWishlist = (
  <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3727 4.88502C12.3727 6.97945 10.6771 8.67543 8.58432 8.67543C6.49055 8.67543 4.79492 6.97945
    4.79492 4.88502C4.79492 2.79303 6.49034 1.09766 8.58432 1.09766C10.6769 1.09786 12.3727 2.79303 12.3727
    4.88502Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17.2371 18.9805C17.2371 21.5428 1.04102 21.5428 1.04102 18.9805C1.04102 15.1375 4.6652 12.2363
    9.13892 12.2363C13.614 12.2363 17.2371 15.1375 17.2371 18.9805Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M21.3019 2.71905L21.9999 3.39928L22.6978 2.71897C23.1576 2.2708 23.7745 2 24.453 2C25.8445 2 27
    3.15103 27 4.605C27 5.3226 26.7165 5.96945 26.2586 6.44062L26.23 6.47003L26.2039 6.50168C26.202 6.50395
    26.2003 6.50597 26.1988 6.50776C26.1964 6.51067 26.1944 6.51297 26.1928 6.51475C26.1911 6.51664 26.1901
    6.51765 26.1899 6.5179L26.1882 6.5196L22.1683 10.6058C22.1682 10.6059 22.1681 10.6061 22.1679 10.6062C22.1372
    10.6373 22.0946 10.6667 21.9902 10.6667C21.9366 10.6667 21.8898 10.6478 21.8494 10.6065L21.8478 10.605L17.9046
    6.5979L17.8841 6.57712L17.8625 6.55758C17.334 6.07969 17 5.38397 17 4.60514C17 3.15113 18.1556 2 19.5475 2C20.225
    2 20.8417 2.27064 21.3019 2.71905Z"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);

export const lkOrder = (
  <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3727 4.88502C12.3727 6.97945 10.6771 8.67543 8.58432 8.67543C6.49055 8.67543 4.79492
    6.97945 4.79492 4.88502C4.79492 2.79303 6.49034 1.09766 8.58432 1.09766C10.6769 1.09786 12.3727 2.79303
    12.3727 4.88502Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17.2371 18.9805C17.2371 21.5428 1.04102 21.5428 1.04102 18.9805C1.04102 15.1375 4.6652 12.2363
    9.13892 12.2363C13.614 12.2363 17.2371 15.1375 17.2371 18.9805Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M26.7788 9H15.222C15.1607 9 15.1017 8.97375 15.0593 8.92731C15.0179 8.88102 14.9962 8.81857
    15.0005 8.7554C15.2254 5.5281 17.8603 3 21.0004 3C24.1397 3 26.7755 5.5281 26.9994 8.7554C27.0038 8.81857
    26.9831 8.88102 26.9406 8.92731C26.8992 8.9739 26.8404 9 26.7788 9Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M20.9999 3C20.4482 3 20 2.55132 20 1.99992C20 1.44868 20.4482 1 20.9999 1C21.5507 1 22 1.44868
    22 1.99992C22 2.55132 21.5507 3 20.9999 3Z"
      stroke="white"
      strokeWidth="2"
    />
    <path d="M14 9.5H27.7432" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const search = (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="search store icon"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.135498 15.0447C-0.0621697 15.284
    -0.0402067 15.632 0.179424 15.8496C0.421017 16.0671 0.772425 16.0454 0.992056 15.8061L3.67155 12.8693C5.05522
    13.8483 6.76833 14.3486 8.63519 14.131C11.9516 13.783 14.6091 11.1508 14.9605 7.86604C15.4218 3.45008 11.7759
    -0.248015 7.36133 0.0130272C3.80332 0.230562 0.904204 3.10202 0.684573 6.64784C0.552795 8.80144 1.38739 10.7593
    2.79302 12.1297L0.135498 15.0447ZM8.5288 13.1366C6.96626 13.3186 5.49469 12.9303 4.25838 12.0556L3.88604
    11.7922L3.5013 11.4171C2.25286 10.1999 1.58242 8.50505 1.69236 6.70834C1.88054 3.67028 4.37117 1.19775
    7.42354 1.01113C11.2376 0.785597 14.351 3.98375 13.9563 7.76314C13.6553 10.5765 11.3718 12.8382 8.5288 13.1366Z"
      fill="#616161"
    />
  </svg>
);

export const rightOrangeArrow = (
  <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="more arrow copy"
      d="M15.7299 9.34479C15.552 9.54689 15.2481 9.54834 15.0769 9.36829C14.9028 9.18534
    14.8901 8.8495 15.0553 8.65725L18.4792 5.50104L0.459187 5.50104C0.205578 5.50104 0 5.27719 0 5.00104C0 4.72489
    0.205578 4.50105 0.459187 4.50105L18.4792 4.50105L15.0553 1.34486C14.8899 1.15261 14.9001 0.813816 15.0769
    0.633818C15.2535 0.453819 15.5377 0.449369 15.7299 0.657318L19.8856 4.65725C20.0602 4.89124 20.0143 5.17804
    19.8856 5.34484L15.7299 9.34479Z"
      fill="#E74E1A"
    />
  </svg>
);

export const faqIcon90 = (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="icon support"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.83607 2.69841H10.8197V1.40635C10.8197
    0.629705 10.1693 0 9.36721 0H2.43607C1.09068 0 0 1.05606 0 2.35873L0 14.4667C0 15.7693 1.09068 16.8254 2.43607
    16.8254H4.09836V15.873H2.43607C1.63391 15.873 0.983607 15.2434 0.983607 14.4667L0.983607 2.35873C0.983607
    1.58204 1.63391 0.952381 2.43607 0.952381H9.36721C9.62609 0.952381 9.83607 1.15569 9.83607 1.40635V2.69841ZM16.3934
    17.6413V16.1905H19.1803C19.5191 16.1905 19.823 15.9887 19.945 15.6826C19.9816 15.5906 20 15.494
    20 15.3968C20 15.1746 19.9035 14.9609 19.7321 14.8098L16.3934 11.8712L16.3934 5.53333C16.3934 4.23231
    15.3012 3.1746 13.9577 3.1746L7.02623 3.1746C5.68248 3.1746 4.59016 4.23225 4.59016 5.53333L4.59016
    17.6413C4.59016 18.9423 5.68242 20 7.0259 20L13.9574 20C15.3011 20 16.3934 18.9424 16.3934 17.6413ZM5.57377
    17.6413L5.57377 5.53333C5.57377 4.75823 6.22571 4.12698 7.02623 4.12698H13.9577C14.7579 4.12698 15.4098
    4.75827 15.4098 5.53333V12.2926L18.7564 15.2381H15.4098V17.6413C15.4098 18.4164 14.7579 19.0476 13.9574
    19.0476L7.0259 19.0476C6.22568 19.0476 5.57377 18.4163 5.57377 17.6413ZM11.3115 15.2381C11.3115 14.7121
    10.8711 14.2857 10.3279 14.2857C9.78464 14.2857 9.34426 14.7121 9.34426 15.2381C9.34426 15.7641 9.78464
    16.1905 10.3279 16.1905C10.8711 16.1905 11.3115 15.7641 11.3115 15.2381ZM10.3279 6.66667C10.8711 6.66667
    11.3115 7.09306 11.3115 7.61905C11.3115 8.14503 10.8711 8.57143 10.3279 8.57143C9.78464 8.57143 9.34426
    8.14503 9.34426 7.61905C9.34426 7.09306 9.78464 6.66667 10.3279 6.66667ZM11.3115 11.4286C11.3115 10.9026
    10.8711 10.4762 10.3279 10.4762C9.78464 10.4762 9.34426 10.9026 9.34426 11.4286C9.34426 11.9546 9.78464 12.381
    10.3279 12.381C10.8711 12.381 11.3115 11.9546 11.3115 11.4286Z"
      fill="#fff"
    />
  </svg>
);

export const popupClose = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="x small"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 5L12 0L14 2L9 7L14 12L12 14L7 9L2 14L0 12L5
    7L0 2L2 0L7 5Z"
      fill="#8E8E8E"
    />
  </svg>
);

export const faqPopUpTelegram = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 22" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0794072 1.82351C0.100412 1.8896 0.846962 3.84706 1.73843 6.17342C2.62985 8.49978 4.31963 12.9122 5.49344 15.9787C7.79947 22.0032 7.6979 21.7734 8.08642 21.8464C8.30939 21.8882 8.58726 21.8054 8.72852 21.655C8.85114 21.5245 10.58 16.5106 10.5391 16.4041C10.5264 16.3708 8.90011 13.7006 6.92525 10.4705C3.22745 4.42211 3.23927 4.44307 3.52151 4.44307C3.57789 4.44307 4.349 5.24427 5.60711 6.61C6.70497 7.80178 8.55856 9.81456 9.72616 11.0828L11.8491 13.3887L14.1484 13.5503C15.4131 13.6392 16.5068 13.6972 16.5788 13.6791C16.736 13.6396 16.8755 13.4007 16.8282 13.2519C16.8104 13.1954 16.182 12.5215 15.4319 11.7543C14.6817 10.987 14.068 10.3409 14.068 10.3185C14.068 10.2853 15.8284 7.94044 17.5587 5.66873C17.75 5.41759 17.9297 5.15121 17.958 5.07681C18.093 4.72161 17.9292 4.21783 17.6071 3.99736C17.4808 3.91089 15.7627 3.51699 9.3786 2.11079C4.94069 1.13329 1.24667 0.333485 1.16958 0.333485C0.884213 0.333485 0.63634 0.44788 0.391832 0.69234C0.0685444 1.01563 -0.0457549 1.42947 0.0794072 1.82351Z"
    />
  </svg>
);

export const viber = (
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 88 88" fill="none">
    <rect x="0.408691" y="0.302368" width="87.1651" height="87.1651" rx="22.2413" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M39.0998 10.7845C32.1842 11.3445 26.2929 13.097 22.262 15.7932C17.8295 18.7579 15.1364 24.244 14.2204 32.1735C13.7613 36.1485 13.7596 43.8826 14.2171 47.5797C15.4255 57.3442 19.8199 63.5444 27.3685 66.1355L28.429 66.4996L28.4292 70.2367C28.4292 73.211 28.4692 74.1086 28.6252 74.6339C28.9729 75.8044 29.771 76.4646 30.8356 76.462C31.9627 76.4592 33.1271 75.3983 36.8252 71.0047L38.8765 68.5674L43.9057 68.5526C49.1539 68.5372 50.3056 68.4558 54.013 67.8385C55.8539 67.5319 59.0675 66.7328 60.7626 66.1601C66.917 64.0809 71.0046 59.5337 72.7654 52.8078C74.0147 48.0351 74.5011 39.3649 73.8665 33.1757C73.0922 25.6245 70.8499 20.1804 67.1607 16.8939C63.5041 13.6367 56.5881 11.41 48.1561 10.7754C46.0778 10.6189 41.0817 10.6239 39.0998 10.7845ZM39.2927 15.4007C32.2506 16.0259 26.51 18.0831 23.6055 21.0223C21.1613 23.4958 19.5895 27.1523 18.8611 32.059C18.303 35.8187 18.2488 44.4382 18.7626 47.7324C19.5193 52.5843 20.9774 55.8018 23.5981 58.4023C25.1481 59.9405 27.1792 61.172 29.3934 61.9164L30.1648 62.1757V68.0131C30.1648 74.3189 30.1603 74.2776 30.8437 74.2776C31.067 74.2776 31.35 74.0849 31.7408 73.667C32.3387 73.0275 37.1561 67.2804 38.9139 65.1095L39.9355 63.8479L43.8566 63.8074C49.0716 63.7535 52.0284 63.3969 56.3914 62.2955C59.6276 61.4786 60.9473 60.9416 62.7181 59.7211C63.7839 58.9866 65.3092 57.4406 66.0607 56.3333C68.561 52.6494 69.4792 48.092 69.4909 39.3087C69.495 36.2043 69.4435 34.8238 69.2696 33.3949C68.5728 27.6622 67.1301 23.7276 64.7583 21.0911C62.3351 18.3975 57.1973 16.4931 49.8991 15.5831C47.997 15.3459 41.2215 15.2293 39.2927 15.4007ZM43.0412 22.6581C42.8888 22.8105 42.8272 23.0365 42.8535 23.3479C42.9039 23.9467 43.2638 24.1339 44.3709 24.1369C46.1674 24.1419 48.598 24.7587 50.4305 25.675C53.1701 27.0444 55.2038 29.0585 56.6059 31.7903C57.762 34.0427 58.3172 36.1744 58.5117 39.1082C58.6323 40.9267 58.7162 41.1086 59.4342 41.1086C59.6786 41.1086 59.8624 41.0018 60.0129 40.7722C60.4634 40.0846 59.8402 35.5748 58.9581 33.1378C56.6933 26.8817 51.2763 22.8457 44.6871 22.5049C43.4416 22.4405 43.2399 22.4593 43.0412 22.6581ZM32.1127 24.4611C30.7063 24.8182 28.354 26.9261 27.61 28.4964C27.2787 29.1958 27.2078 29.5036 27.2078 30.2451C27.2078 31.0925 27.2743 31.2992 28.3432 33.7806C31.9379 42.1259 35.4692 46.8889 41.2224 51.1519C44.6594 53.6986 50.9417 57.0279 52.9476 57.3658C53.6429 57.4829 54.7303 57.175 55.6107 56.6119C56.9623 55.7473 58.7836 53.3638 59.0511 52.1095C59.2467 51.1924 59.0229 50.6498 58.0621 49.7119C56.3941 48.0835 52.7661 45.5773 51.7428 45.3465C51.2464 45.2345 50.3545 45.3645 49.8816 45.6177C49.7485 45.6889 49.2358 46.2591 48.7422 46.8848C47.8275 48.0443 47.7194 48.1308 46.9568 48.3134C46.4229 48.441 45.2344 48.0999 43.9209 47.4418C40.6001 45.7781 38.1482 43.0449 36.4797 39.1471C35.5605 36.9995 35.6567 36.5246 37.2925 35.1368C38.6334 33.9991 38.908 33.4847 38.8205 32.2741C38.7753 31.6513 38.6443 31.3209 38.0155 30.2448C37.0917 28.6638 36.3913 27.6579 35.085 26.0367C33.7772 24.4138 33.2985 24.16 32.1127 24.4611ZM44.5288 26.9093C44.195 27.143 44.1337 27.8682 44.4232 28.1578C44.5227 28.2573 45.1029 28.4085 45.7127 28.4937C49.7832 29.0632 52.6413 31.289 53.7987 34.7912C54.0166 35.4506 54.1917 36.3857 54.2876 37.4028C54.4469 39.0907 54.5896 39.4373 55.1257 39.4373C55.6697 39.4373 55.9415 39.0121 55.9415 38.1609C55.9415 32.6227 52.3257 28.0962 47.0707 27.0556C45.3654 26.718 44.8446 26.688 44.5288 26.9093ZM45.6565 31.4664C45.5151 31.6079 45.3994 31.8571 45.3994 32.0204C45.3994 32.5644 45.6804 32.7633 46.6988 32.9402C48.8396 33.3118 49.8715 34.4103 50.1479 36.6112C50.2176 37.1656 50.3517 37.6269 50.4867 37.7761C50.9752 38.316 51.8294 37.8787 51.8253 37.091C51.824 36.8613 51.7393 36.2778 51.6368 35.7945C51.1321 33.4122 49.7506 31.9205 47.5737 31.4074C46.4496 31.1425 45.9656 31.1574 45.6565 31.4664Z" fill="#9069AE" />
  </svg>
);

export const telegram = (
  <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 88 88" fill="none">
    <rect x="0.679199" y="0.30249" width="87.1651" height="87.1651" rx="22.2413" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M68.7665 20.1169C68.5897 20.173 63.354 22.1699 57.1316 24.5543C50.9092 26.9386 39.1072 31.4584 30.9049 34.598C14.7909 40.766 15.4056 40.4943 15.2106 41.5335C15.0987 42.1299 15.3201 42.8731 15.7224 43.251C16.0714 43.5789 29.4822 48.2032 29.7671 48.0939C29.8564 48.0597 36.9982 43.7099 45.6381 38.4277C61.8159 28.537 61.7598 28.5687 61.7598 29.3236C61.7598 29.4744 59.6168 31.5369 55.9639 34.902C52.7762 37.8385 47.3925 42.7964 44.0003 45.9194L37.8326 51.5976L37.4003 57.7478C37.1625 61.1304 37.0075 64.0558 37.056 64.2485C37.1614 64.6688 37.8006 65.042 38.1986 64.9156C38.3496 64.8678 40.152 63.187 42.2042 61.1806C44.2565 59.1743 45.9846 57.5328 46.0447 57.5328C46.1335 57.5328 52.4053 62.2413 58.4815 66.8695C59.1532 67.3812 59.8657 67.8616 60.0647 67.9374C61.0148 68.2985 62.3623 67.8605 62.952 66.9988C63.1833 66.661 64.2368 62.0655 67.9981 44.9898C70.6126 33.1195 72.7519 23.239 72.7519 23.0328C72.7519 22.2695 72.4459 21.6065 71.792 20.9525C70.9273 20.0878 69.8204 19.7821 68.7665 20.1169Z" fill="#34AADF" />
  </svg>
);

export const shareIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_43_233)">
      <path d="M19.5888 7.25525H17.4123V8.70631H18.8634V21.7657H4.35291V8.70631H5.80397V7.25525H3.62738C3.22635 7.25525 2.90186 7.57974 2.90186 7.98078V22.4912C2.90186 22.8922 3.22635 23.2167 3.62738 23.2167H19.5888C19.9899 23.2167 20.3144 22.8922 20.3144 22.4912V7.98078C20.3144 7.57974 19.9899 7.25525 19.5888 7.25525Z" fill="#FCFCFC" />
      <path d="M10.8828 2.77741V13.0594H12.3338V2.77741L15.4484 5.89205L16.4744 4.86612L11.6083 3.05176e-05L6.74219 4.86612L7.76811 5.89205L10.8828 2.77741Z" fill="#FCFCFC" />
    </g>
    <defs>
      <clipPath id="clip0_43_233">
        <rect width="23.2167" height="23.2167" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
